// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// -- views
import NumberInput from './NumberInput';
import {CurrencyUtils} from "../../utils"

export default class PriceInput extends Component {

  static defaultProps = {
    readOnly: false
  };

  static propTypes = {
    value: PropTypes.number.isRequired,

    // param: number, the chosen vat
    onChange: PropTypes.func.isRequired,

    currencyCode: PropTypes.string.isRequired,

    readOnly: PropTypes.bool
  };

  onChange = (value) => {
    if (!this.props.readOnly) {
      this.props.onChange(value);
    }
  };

  render() {
    return (
      <div className="price_input input-group">
        <NumberInput
          className="form-control"
          value={this.props.value}
          onChange={this.onChange}
          min={0}
          max={10000}
          format={NumberInput.CURRENCY_FORMAT}
          disabled={this.props.readOnly}
        />
        <div className="input-group-addon">
          {CurrencyUtils.getCurrencySymbol(this.props.currencyCode)}
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/PriceInput.js